<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small>Bei bestehendem Account Anmelden</small>
            <div v-if="error"><small><b>Es ist ein Fehler aufgetreten. Bitte versuche es erneut.</b></small></div>
          </div>

          <form v-on:submit.prevent="checkForm">
            <base-input :valid="emailValid"
                        addon-left-icon="ni ni-email-83"
                        class="input-group-alternative mb-3"
                        placeholder="E-Mail"
                        v-model="email">
            </base-input>

            <base-input :valid="passwordValid"
                        addon-left-icon="ni ni-lock-circle-open"
                        class="input-group-alternative"
                        placeholder="Passwort"
                        type="password"
                        v-model="password">
            </base-input>

            <div class="text-center">
              <base-button class="my-4" native-type="submit" type="primary">Anmelden</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a class="text-light" href="#"><small>Passwort vergessen?</small></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import firebase from 'firebase/app';
  import store from "../store";
  require('firebase/auth');

  export default {
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
        emailValid: null,
        passwordValid: null,
        error: false
      }
    },
    methods: {
      checkForm: function (e) {
        if (!this.password) {
          this.passwordValid = false;
        } else {
          this.passwordValid = true;
        }
        if (!this.email) {
          this.emailValid = false;
        } else this.emailValid = this.validEmail(this.email);

        if (this.emailValid && this.passwordValid) {
          firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
            const isAuthenticated = firebase.auth().currentUser;

            const docRef = firebase.firestore().collection("users").doc(isAuthenticated.uid);

            docRef.get().then(function (doc) {
              if (doc.exists) {
                // eslint-disable-next-line no-console
                const user = {
                  uid: isAuthenticated.uid,
                  is_admin: doc.data().is_admin,
                  email: isAuthenticated.email,
                  firstname: doc.data().firstname,
                  lastname: doc.data().lastname,
                  image: doc.data().image
                };
                store.commit('addUser', user)
              } else {
                // doc.data() will be undefined in this case
                // eslint-disable-next-line no-console
                console.log("No such document!");
              }
            }).catch(function (error) {
              // eslint-disable-next-line no-console
              console.log("Error getting document:", error);
            });

            this.$router.push({ name: "dashboard" });
          })
            .catch(error => {
              this.error = error;
            });
        }

        e.preventDefault();
      },
      validEmail: function (email) {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        return re.test(email);
      }
    }
  }
</script>
<style>
</style>
